import { c as _c } from "react/compiler-runtime";
import { IcoArrowTopRight16, IcoEye16 } from '@onefootprint/icons';
import { LinkButton } from '@onefootprint/ui';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormattedWatchlistHit } from '../../../../../../onboarding-business-insight.types';
type HitItemProps = {
  hit: FormattedWatchlistHit;
};
const HitItem = t0 => {
  const $0 = _c(24);
  const {
    hit: t1
  } = t0;
  const {
    entityName,
    entityAliases,
    agency,
    listName,
    agencyListUrl,
    listCountry
  } = t1;
  let t2;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "onboardings.watchlist.list"
    };
    $0[0] = t2;
  } else {
    t2 = $0[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const [isAliasTruncated, setIsAliasTruncated] = useState(false);
  const nameRef = useRef(null);
  let t3;
  if ($0[1] !== agency || $0[2] !== listCountry) {
    t3 = [agency, listCountry].filter(Boolean);
    $0[1] = agency;
    $0[2] = listCountry;
    $0[3] = t3;
  } else {
    t3 = $0[3];
  }
  const details = t3;
  let t4;
  let t5;
  if ($0[4] !== entityAliases) {
    t4 = () => {
      const aliasElement = nameRef.current;
      if (aliasElement && entityAliases) {
        setIsAliasTruncated(aliasElement.offsetWidth < aliasElement.scrollWidth);
      }
    };
    t5 = [entityAliases];
    $0[4] = entityAliases;
    $0[5] = t4;
    $0[6] = t5;
  } else {
    t4 = $0[5];
    t5 = $0[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($0[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div><IcoEye16 /></div>;
    $0[7] = t6;
  } else {
    t6 = $0[7];
  }
  let t7;
  if ($0[8] !== entityName) {
    t7 = <h3 className="text-label-2 text-primary">{entityName}</h3>;
    $0[8] = entityName;
    $0[9] = t7;
  } else {
    t7 = $0[9];
  }
  let t8;
  if ($0[10] !== entityAliases || $0[11] !== isAliasTruncated || $0[12] !== t) {
    t8 = entityAliases.length > 0 && <p className="text-body-2 text-secondary truncate" ref={nameRef} title={isAliasTruncated ? entityAliases.join(", ") : undefined}>{t($ => $[entityAliases.length === 1 ? "alias_one" : "alias_other"], {
        count: entityAliases.length,
        list: entityAliases.join(", ")
      })}</p>;
    $0[10] = entityAliases;
    $0[11] = isAliasTruncated;
    $0[12] = t;
    $0[13] = t8;
  } else {
    t8 = $0[13];
  }
  let t9;
  if ($0[14] !== details) {
    t9 = details.length > 0 && <p className="text-body-2 text-secondary">{details.join(" \u22C5 ")}</p>;
    $0[14] = details;
    $0[15] = t9;
  } else {
    t9 = $0[15];
  }
  let t10;
  if ($0[16] !== agencyListUrl || $0[17] !== listName) {
    t10 = agencyListUrl ? <LinkButton href={agencyListUrl} iconComponent={IcoArrowTopRight16} target="_blank">{listName}</LinkButton> : <p className="text-body-2 text-secondary">{listName}</p>;
    $0[16] = agencyListUrl;
    $0[17] = listName;
    $0[18] = t10;
  } else {
    t10 = $0[18];
  }
  let t11;
  if ($0[19] !== t10 || $0[20] !== t7 || $0[21] !== t8 || $0[22] !== t9) {
    t11 = <div className="w-full p-3 border border-tertiary rounded-md flex gap-3 overflow-hidden">{t6}<div className="flex flex-col gap-1 flex-1 min-w-0">{t7}{t8}{t9}{t10}</div></div>;
    $0[19] = t10;
    $0[20] = t7;
    $0[21] = t8;
    $0[22] = t9;
    $0[23] = t11;
  } else {
    t11 = $0[23];
  }
  return t11;
};
export default HitItem;